import axios from "axios";
import { baseUrl, apiKey } from "../config";

const StandingService = {
  getLeaguesStanding: async (leagueId, type) => {
    try {
      const response = await axios.get(
        `${baseUrl}/standing/?leagueId=${leagueId}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getTopScorers: async (leagueId, season) => {
    try {
      const response = await axios.get(
        `${baseUrl}/standing/top-ghi-ban?leagueId=${leagueId}&season=${season}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
  getFifaRanking: async (type) => {
    try {
      const response = await axios.get(
        `${baseUrl}/standing/xep-hang-fifa?type=${type}`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
        }
      );
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default StandingService;
